import { ReferralOverviewFieldsFragment, ReferralSaleState } from '../../../types/graphqlTypes';

type Sale = ReferralOverviewFieldsFragment['sales'][number];

const net = (sales: Sale[]) => sales.reduce((sum, sale) => sum + sale.amountCents - sale.cutCents, 0);
const isPaid = (sale: Sale) => sale.state === ReferralSaleState.Payable || sale.state === ReferralSaleState.PaidOut;

/**
 * A reseller's or full-service partner's money as it sees it: what it pays Pythagoras, its discount already off — for
 * the orders not invoiced yet (sales checks each order, then sends its invoice), on an invoice not paid yet, and
 * paid — and its discount.
 */
export const partnerTotals = (sales: Sale[]) => ({
  orders: sales.length,
  discountCents: sales.reduce((sum, sale) => sum + sale.cutCents, 0),
  notInvoicedCents: net(sales.filter((sale) => !sale.odooInvoiceId)),
  awaitingPaymentCents: net(sales.filter((sale) => !!sale.odooInvoiceId && !isPaid(sale))),
  paidCents: net(sales.filter(isPaid)),
});
